/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/example/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cx = __webpack_require__(4);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Tree = __webpack_require__(9);
	var tree = __webpack_require__(7);
	
	__webpack_require__(17);
	__webpack_require__(16);
	__webpack_require__(15);
	
	var App = React.createClass({
	  displayName: 'App',
	  getInitialState: function getInitialState() {
	    return {
	      active: null,
	      tree: tree
	    };
	  },
	  renderNode: function renderNode(node) {
	    return React.createElement(
	      'span',
	      { className: cx('node', {
	          'is-active': node === this.state.active
	        }), onClick: this.onClickNode.bind(null, node) },
	      node.module
	    );
	  },
	  onClickNode: function onClickNode(node) {
	    this.setState({
	      active: node
	    });
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'app' },
	      React.createElement(
	        'div',
	        { className: 'tree' },
	        React.createElement(Tree, {
	          paddingLeft: 20,
	          tree: this.state.tree,
	          onChange: this.handleChange,
	          isNodeCollapsed: this.isNodeCollapsed,
	          renderNode: this.renderNode
	        })
	      ),
	      React.createElement(
	        'div',
	        { className: 'inspector' },
	        React.createElement(
	          'button',
	          { onClick: this.updateTree },
	          'update tree'
	        ),
	        React.createElement(
	          'pre',
	          null,
	          JSON.stringify(this.state.tree, null, '  ')
	        )
	      )
	    );
	  },
	  handleChange: function handleChange(tree) {
	    this.setState({
	      tree: tree
	    });
	  },
	  updateTree: function updateTree() {
	    var tree = this.state.tree;
	    tree.children.push({ module: 'test' });
	    this.setState({
	      tree: tree
	    });
	  }
	});
	
	ReactDOM.render(React.createElement(App, null), document.getElementById('app'));

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function () {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for (var i = 0; i < this.length; i++) {
				var item = this[i];
				if (item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function (modules, mediaQuery) {
			if (typeof modules === "string") modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for (var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if (typeof id === "number") alreadyImportedModules[id] = true;
			}
			for (i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if (mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if (mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(5)) === 'object' && __webpack_require__(5)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ },
/* 5 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  module: 'react-ui-tree',
	  children: [{
	    module: 'dist',
	    collapsed: true,
	    children: [{
	      module: 'node.js',
	      leaf: true
	    }, {
	      module: 'react-ui-tree.css',
	      leaf: true
	    }, {
	      module: 'react-ui-tree.js',
	      leaf: true
	    }, {
	      module: 'tree.js',
	      leaf: true
	    }]
	  }, {
	    module: 'example',
	    children: [{
	      module: 'app.js',
	      leaf: true
	    }, {
	      module: 'app.less',
	      leaf: true
	    }, {
	      module: 'index.html',
	      leaf: true
	    }]
	  }, {
	    module: 'lib',
	    children: [{
	      module: 'node.js',
	      leaf: true
	    }, {
	      module: 'react-ui-tree.js',
	      leaf: true
	    }, {
	      module: 'react-ui-tree.less',
	      leaf: true
	    }, {
	      module: 'tree.js',
	      leaf: true
	    }]
	  }, {
	    module: '.gitiignore',
	    leaf: true
	  }, {
	    module: 'index.js',
	    leaf: true
	  }, {
	    module: 'LICENSE',
	    leaf: true
	  }, {
	    module: 'Makefile',
	    leaf: true
	  }, {
	    module: 'package.json',
	    leaf: true
	  }, {
	    module: 'README.md',
	    leaf: true
	  }, {
	    module: 'webpack.config.js',
	    leaf: true
	  }]
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cx = __webpack_require__(4);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	
	var Node = React.createClass({
	  displayName: 'UITreeNode',
	
	  renderCollapse: function renderCollapse() {
	    var index = this.props.index;
	
	    if (index.children && index.children.length) {
	      var collapsed = index.node.collapsed;
	
	      return React.createElement('span', {
	        className: cx('collapse', collapsed ? 'caret-right' : 'caret-down'),
	        onMouseDown: function onMouseDown(e) {
	          e.stopPropagation();
	        },
	        onClick: this.handleCollapse });
	    }
	
	    return null;
	  },
	  renderChildren: function renderChildren() {
	    var _this = this;
	
	    var index = this.props.index;
	    var tree = this.props.tree;
	    var dragging = this.props.dragging;
	
	    if (index.children && index.children.length) {
	      var childrenStyles = {};
	      if (index.node.collapsed) childrenStyles.display = 'none';
	      childrenStyles['paddingLeft'] = this.props.paddingLeft + 'px';
	
	      return React.createElement(
	        'div',
	        { className: 'children', style: childrenStyles },
	        index.children.map(function (child) {
	          var childIndex = tree.getIndex(child);
	          return React.createElement(Node, {
	            tree: tree,
	            index: childIndex,
	            key: childIndex.id,
	            dragging: dragging,
	            paddingLeft: _this.props.paddingLeft,
	            onCollapse: _this.props.onCollapse,
	            onDragStart: _this.props.onDragStart
	          });
	        })
	      );
	    }
	
	    return null;
	  },
	  render: function render() {
	    var tree = this.props.tree;
	    var index = this.props.index;
	    var dragging = this.props.dragging;
	    var node = index.node;
	    var styles = {};
	
	    return React.createElement(
	      'div',
	      { className: cx('m-node', {
	          'placeholder': index.id === dragging
	        }), style: styles },
	      React.createElement(
	        'div',
	        { className: 'inner', ref: 'inner', onMouseDown: this.handleMouseDown },
	        this.renderCollapse(),
	        tree.renderNode(node)
	      ),
	      this.renderChildren()
	    );
	  },
	  handleCollapse: function handleCollapse(e) {
	    e.stopPropagation();
	    var nodeId = this.props.index.id;
	    if (this.props.onCollapse) this.props.onCollapse(nodeId);
	  },
	  handleMouseDown: function handleMouseDown(e) {
	    var nodeId = this.props.index.id;
	    var dom = this.refs.inner;
	
	    if (this.props.onDragStart) {
	      this.props.onDragStart(nodeId, dom, e);
	    }
	  }
	});
	
	module.exports = Node;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(3);
	var Tree = __webpack_require__(10);
	var Node = __webpack_require__(8);
	
	module.exports = React.createClass({
	  displayName: 'UITree',
	
	  propTypes: {
	    tree: React.PropTypes.object.isRequired,
	    paddingLeft: React.PropTypes.number,
	    renderNode: React.PropTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      paddingLeft: 20
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.init(this.props);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!this._updated) this.setState(this.init(nextProps));else this._updated = false;
	  },
	  init: function init(props) {
	    var tree = new Tree(props.tree);
	    tree.isNodeCollapsed = props.isNodeCollapsed;
	    tree.renderNode = props.renderNode;
	    tree.changeNodeCollapsed = props.changeNodeCollapsed;
	    tree.updateNodesPosition();
	
	    return {
	      tree: tree,
	      dragging: {
	        id: null,
	        x: null,
	        y: null,
	        w: null,
	        h: null
	      }
	    };
	  },
	  getDraggingDom: function getDraggingDom() {
	    var tree = this.state.tree;
	    var dragging = this.state.dragging;
	
	    if (dragging && dragging.id) {
	      var draggingIndex = tree.getIndex(dragging.id);
	      var draggingStyles = {
	        top: dragging.y,
	        left: dragging.x,
	        width: dragging.w
	      };
	
	      return React.createElement(
	        'div',
	        { className: 'm-draggable', style: draggingStyles },
	        React.createElement(Node, {
	          tree: tree,
	          index: draggingIndex,
	          paddingLeft: this.props.paddingLeft
	        })
	      );
	    }
	
	    return null;
	  },
	  render: function render() {
	    var tree = this.state.tree;
	    var dragging = this.state.dragging;
	    var draggingDom = this.getDraggingDom();
	
	    return React.createElement(
	      'div',
	      { className: 'm-tree' },
	      draggingDom,
	      React.createElement(Node, {
	        tree: tree,
	        index: tree.getIndex(1),
	        key: 1,
	        paddingLeft: this.props.paddingLeft,
	        onDragStart: this.dragStart,
	        onCollapse: this.toggleCollapse,
	        dragging: dragging && dragging.id
	      })
	    );
	  },
	  dragStart: function dragStart(id, dom, e) {
	    this.dragging = {
	      id: id,
	      w: dom.offsetWidth,
	      h: dom.offsetHeight,
	      x: dom.offsetLeft,
	      y: dom.offsetTop
	    };
	
	    this._startX = dom.offsetLeft;
	    this._startY = dom.offsetTop;
	    this._offsetX = e.clientX;
	    this._offsetY = e.clientY;
	    this._start = true;
	
	    window.addEventListener('mousemove', this.drag);
	    window.addEventListener('mouseup', this.dragEnd);
	  },
	
	  // oh
	  drag: function drag(e) {
	    if (this._start) {
	      this.setState({
	        dragging: this.dragging
	      });
	      this._start = false;
	    }
	
	    var tree = this.state.tree;
	    var dragging = this.state.dragging;
	    var paddingLeft = this.props.paddingLeft;
	    var newIndex = null;
	    var index = tree.getIndex(dragging.id);
	    var collapsed = index.node.collapsed;
	
	    var _startX = this._startX;
	    var _startY = this._startY;
	    var _offsetX = this._offsetX;
	    var _offsetY = this._offsetY;
	
	    var pos = {
	      x: _startX + e.clientX - _offsetX,
	      y: _startY + e.clientY - _offsetY
	    };
	    dragging.x = pos.x;
	    dragging.y = pos.y;
	
	    var diffX = dragging.x - paddingLeft / 2 - (index.left - 2) * paddingLeft;
	    var diffY = dragging.y - dragging.h / 2 - (index.top - 2) * dragging.h;
	
	    if (diffX < 0) {
	      // left
	      if (index.parent && !index.next) {
	        newIndex = tree.move(index.id, index.parent, 'after');
	      }
	    } else if (diffX > paddingLeft) {
	      // right
	      if (index.prev) {
	        var prevNode = tree.getIndex(index.prev).node;
	        if (!prevNode.collapsed && !prevNode.leaf) {
	          newIndex = tree.move(index.id, index.prev, 'append');
	        }
	      }
	    }
	
	    if (newIndex) {
	      index = newIndex;
	      newIndex.node.collapsed = collapsed;
	      dragging.id = newIndex.id;
	    }
	
	    if (diffY < 0) {
	      // up
	      var above = tree.getNodeByTop(index.top - 1);
	      newIndex = tree.move(index.id, above.id, 'before');
	    } else if (diffY > dragging.h) {
	      // down
	      if (index.next) {
	        var below = tree.getIndex(index.next);
	        if (below.children && below.children.length && !below.node.collapsed) {
	          newIndex = tree.move(index.id, index.next, 'prepend');
	        } else {
	          newIndex = tree.move(index.id, index.next, 'after');
	        }
	      } else {
	        var below = tree.getNodeByTop(index.top + index.height);
	        if (below && below.parent !== index.id) {
	          if (below.children && below.children.length) {
	            newIndex = tree.move(index.id, below.id, 'prepend');
	          } else {
	            newIndex = tree.move(index.id, below.id, 'after');
	          }
	        }
	      }
	    }
	
	    if (newIndex) {
	      newIndex.node.collapsed = collapsed;
	      dragging.id = newIndex.id;
	    }
	
	    this.setState({
	      tree: tree,
	      dragging: dragging
	    });
	  },
	  dragEnd: function dragEnd() {
	    this.setState({
	      dragging: {
	        id: null,
	        x: null,
	        y: null,
	        w: null,
	        h: null
	      }
	    });
	
	    this.change(this.state.tree);
	    window.removeEventListener('mousemove', this.drag);
	    window.removeEventListener('mouseup', this.dragEnd);
	  },
	  change: function change(tree) {
	    this._updated = true;
	    if (this.props.onChange) this.props.onChange(tree.obj);
	  },
	  toggleCollapse: function toggleCollapse(nodeId) {
	    var tree = this.state.tree;
	    var index = tree.getIndex(nodeId);
	    var node = index.node;
	    node.collapsed = !node.collapsed;
	    tree.updateNodesPosition();
	
	    this.setState({
	      tree: tree
	    });
	
	    this.change(tree);
	  }
	});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tree = __webpack_require__(11);
	var proto = Tree.prototype;
	
	proto.updateNodesPosition = function () {
	  var top = 1;
	  var left = 1;
	  var root = this.getIndex(1);
	  var self = this;
	
	  root.top = top++;
	  root.left = left++;
	
	  if (root.children && root.children.length) {
	    walk(root.children, root, left, root.node.collapsed);
	  }
	
	  function walk(children, parent, left, collapsed) {
	    var height = 1;
	    children.forEach(function (id) {
	      var node = self.getIndex(id);
	      if (collapsed) {
	        node.top = null;
	        node.left = null;
	      } else {
	        node.top = top++;
	        node.left = left;
	      }
	
	      if (node.children && node.children.length) {
	        height += walk(node.children, node, left + 1, collapsed || node.node.collapsed);
	      } else {
	        node.height = 1;
	        height += 1;
	      }
	    });
	
	    if (parent.node.collapsed) parent.height = 1;else parent.height = height;
	    return parent.height;
	  }
	};
	
	proto.move = function (fromId, toId, placement) {
	  if (fromId === toId || toId === 1) return;
	
	  var obj = this.remove(fromId);
	  var index = null;
	
	  if (placement === 'before') index = this.insertBefore(obj, toId);else if (placement === 'after') index = this.insertAfter(obj, toId);else if (placement === 'prepend') index = this.prepend(obj, toId);else if (placement === 'append') index = this.append(obj, toId);
	
	  // todo: perf
	  this.updateNodesPosition();
	  return index;
	};
	
	proto.getNodeByTop = function (top) {
	  var indexes = this.indexes;
	  for (var id in indexes) {
	    if (indexes.hasOwnProperty(id)) {
	      if (indexes[id].top === top) return indexes[id];
	    }
	  }
	};
	
	module.exports = Tree;

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	function Tree(obj) {
	  this.cnt = 1;
	  this.obj = obj || { children: [] };
	  this.indexes = {};
	  this.build(this.obj);
	}
	
	var proto = Tree.prototype;
	
	proto.build = function (obj) {
	  var indexes = this.indexes;
	  var startId = this.cnt;
	  var self = this;
	
	  var index = { id: startId, node: obj };
	  indexes[this.cnt + ''] = index;
	  this.cnt++;
	
	  if (obj.children && obj.children.length) walk(obj.children, index);
	
	  function walk(objs, parent) {
	    var children = [];
	    objs.forEach(function (obj, i) {
	      var index = {};
	      index.id = self.cnt;
	      index.node = obj;
	
	      if (parent) index.parent = parent.id;
	
	      indexes[self.cnt + ''] = index;
	      children.push(self.cnt);
	      self.cnt++;
	
	      if (obj.children && obj.children.length) walk(obj.children, index);
	    });
	    parent.children = children;
	
	    children.forEach(function (id, i) {
	      var index = indexes[id + ''];
	      if (i > 0) index.prev = children[i - 1];
	      if (i < children.length - 1) index.next = children[i + 1];
	    });
	  }
	
	  return index;
	};
	
	proto.getIndex = function (id) {
	  var index = this.indexes[id + ''];
	  if (index) return index;
	};
	
	proto.removeIndex = function (index) {
	  var self = this;
	  del(index);
	
	  function del(index) {
	    delete self.indexes[index.id + ''];
	    if (index.children && index.children.length) {
	      index.children.forEach(function (child) {
	        del(self.getIndex(child));
	      });
	    }
	  }
	};
	
	proto.get = function (id) {
	  var index = this.getIndex(id);
	  if (index && index.node) return index.node;
	  return null;
	};
	
	proto.remove = function (id) {
	  var index = this.getIndex(id);
	  var node = this.get(id);
	  var parentIndex = this.getIndex(index.parent);
	  var parentNode = this.get(index.parent);
	  parentNode.children.splice(parentNode.children.indexOf(node), 1);
	  parentIndex.children.splice(parentIndex.children.indexOf(id), 1);
	  this.removeIndex(index);
	  this.updateChildren(parentIndex.children);
	
	  return node;
	};
	
	proto.updateChildren = function (children) {
	  children.forEach(function (id, i) {
	    var index = this.getIndex(id);
	    index.prev = index.next = null;
	    if (i > 0) index.prev = children[i - 1];
	    if (i < children.length - 1) index.next = children[i + 1];
	  }.bind(this));
	};
	
	proto.insert = function (obj, parentId, i) {
	  var parentIndex = this.getIndex(parentId);
	  var parentNode = this.get(parentId);
	
	  var index = this.build(obj);
	  index.parent = parentId;
	
	  parentNode.children = parentNode.children || [];
	  parentIndex.children = parentIndex.children || [];
	
	  parentNode.children.splice(i, 0, obj);
	  parentIndex.children.splice(i, 0, index.id);
	
	  this.updateChildren(parentIndex.children);
	  if (parentIndex.parent) {
	    this.updateChildren(this.getIndex(parentIndex.parent).children);
	  }
	
	  return index;
	};
	
	proto.insertBefore = function (obj, destId) {
	  var destIndex = this.getIndex(destId);
	  var parentId = destIndex.parent;
	  var i = this.getIndex(parentId).children.indexOf(destId);
	  return this.insert(obj, parentId, i);
	};
	
	proto.insertAfter = function (obj, destId) {
	  var destIndex = this.getIndex(destId);
	  var parentId = destIndex.parent;
	  var i = this.getIndex(parentId).children.indexOf(destId);
	  return this.insert(obj, parentId, i + 1);
	};
	
	proto.prepend = function (obj, destId) {
	  return this.insert(obj, destId, 0);
	};
	
	proto.append = function (obj, destId) {
	  var destIndex = this.getIndex(destId);
	  destIndex.children = destIndex.children || [];
	  return this.insert(obj, destId, destIndex.children.length);
	};
	
	module.exports = Tree;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, "*,:after,:before{box-sizing:border-box}body{margin:0;padding:0;font-size:100%}.inspector{margin-left:400px}.inspector pre{font-family:Menlo;font-size:13px}", ""]);
	
	// exports


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".tree{position:fixed;top:0;left:0;bottom:0;width:300px;overflow-x:hidden;overflow-y:auto;background-color:#21252b}.m-node.placeholder{border:1px dashed #1385e5}.m-node .inner{color:#9da5b4;font-size:12px;font-family:Menlo}.m-node .node{display:inline-block;width:100%;padding:4px 5px}.m-node .node.is-active{background-color:#31363f}", ""]);
	
	// exports


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1)();
	// imports
	
	
	// module
	exports.push([module.id, ".f-no-select,.m-tree{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.m-tree{position:relative;overflow:hidden}.m-draggable{position:absolute;opacity:.8;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.m-node.placeholder>*{visibility:hidden}.m-node.placeholder{border:1px dashed #ccc}.m-node .inner{position:relative;cursor:pointer;padding-left:10px}.m-node .collapse{position:absolute;left:0;cursor:pointer}.m-node .caret-right:before{content:'\\25B8'}.m-node .caret-down:before{content:'\\25BE'}", ""]);
	
	// exports


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(13);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./theme.less", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./theme.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(14);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(2)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./react-ui-tree.less", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/less-loader/index.js!./react-ui-tree.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/